import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { TimeEntry, TimeEntryInput } from '../../entities/timeEntry/timeEntry';
import { TimeEntryCategorySum } from '../../entities/timeEntryCategorySum/timeEntryCategorySum';
import { Page } from '../../entities/page/page';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
/**
 * The users service.
 */
@Injectable()
export class TimeEntryService {

  constructor(
    private apolloService: ApolloService
  ) {
  }
  
  /**
   * updates an user
   * @param userInput user Input
   * @param callback method
   */
  public updateTimeEntry(timeEntryInput: TimeEntryInput, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_TIME_ENTRY_MUTATION,
      {
        timeEntryInput: timeEntryInput,
      },
      callback
    );
  }
  /**
   * creates an user
   * @param userInput user Inout
   * @param callback method
   */
  public createTimeEntry(timeEntryInput: TimeEntryInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_TIME_ENTRY_MUTATION,
      {
        timeEntryInput: timeEntryInput,
      },
      callback
    );
  }
  
  public deleteTimeEntry(timeEntryId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.DELETE_TIME_ENTRY_MUTATION,
      {
        timeEntryId: timeEntryId,
      },
      callback
    );
  }

  /**
   * Get time entries with pagination metadata
   * @param variables filter and pagination parameters
   * @returns Observable of Page<TimeEntry> with totalPages, totalElements, etc.
   */
  public getTimeEntriesPagedWithPagination(variables: fromGraphQl.GetTimeEntriesPagedVariables): Observable<Page<TimeEntry>> {
    return this.apolloService.query<fromGraphQl.GetTimeEntriesPagedResponse>(fromGraphQl.GET_TIME_ENTRIES_PAGED_QUERY, variables)
      .pipe(
        take(1),
        map((result) => {
          const page = new Page<TimeEntry>(result.data.getTimeEntriesPaged);
          page.content = TimeEntry.createTimeEntries(result.data.getTimeEntriesPaged.content || []);
          return page;
        })
      );
  }

  /**
   * Get time entry category sums with total duration per category
   * @param variables filter parameters
   * @returns Observable of TimeEntryCategorySum[] with category details and sum
   */
  public getTimeEntryCategoriesSum(variables: fromGraphQl.GetTimeEntryCategoriesSumVariables): Observable<TimeEntryCategorySum[]> {
    return this.apolloService.query<fromGraphQl.GetTimeEntryCategoriesSumResponse>(
      fromGraphQl.GET_TIME_ENTRY_CATEGORIES_SUM_QUERY, 
      variables
    ).pipe(
      take(1),
      map((result) => {
        return TimeEntryCategorySum.createTimeEntryCategorySums(
          result.data.getTimeEntryCategoriesSum || []
        );
      })
    );
  }

}

